import OnestockTransactionContainer from "./OnestockTransactionContainer";
import OnestockTransactionStore from "./OnestockTransactionStore";

export default OnestockTransactionStore(OnestockTransactionContainer);